<template>
  <main class="container">
    <div class="referral" :class="{ 'is-invalid': !referral.isValid }">
      <h1>Hello!</h1>
      <h2 data-testid="referral-message" v-html="referral.message" />

      <button class="btn btn--big" type="submit" @click="goToSignUp">
        {{ referral.isValid ? "Let's Roll" : "Signup Anyway" }}
      </button>
    </div>

    <section class="benefits">
      <div class="benefit">
        <WalletIcon width="22px" height="26px" />
        <div class="benefit-info">
          <h2>One monthly payment for all bills</h2>
          <p>
            You and your housemates each pay one amount, every month, to cover
            all of your shared bills.
          </p>
        </div>
      </div>

      <div class="benefit">
        <ChartIcon width="22px" height="22px" />
        <div class="benefit-info">
          <h2>Only pay for your share</h2>
          <p>
            No need for a joint account; each pay your share from your own bank
            account.
          </p>
        </div>
      </div>

      <div class="benefit">
        <ThumbsUpIcon width="22px" height="23px" />
        <div class="benefit-info">
          <h2>Share the responsibility</h2>
          <p>
            No need to chase mates for money or choose a chief bill-payer as
            you’re all equally responsible.
          </p>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import WalletIcon from "@/assets/svg/icon-gradient-wallet.svg";
import ChartIcon from "@/assets/svg/icon-gradient-chart.svg";
import ThumbsUpIcon from "@/assets/svg/icon-gradient-thumbs-up.svg";

import { mapState } from "vuex";

export default {
  name: "Referral",
  data() {
    return {};
  },
  computed: {
    ...mapState(["referral"]),
  },
  methods: {
    goToSignUp() {
      this.$router.push("/");
    },
  },
  created() {
    // Tracking page hit events
    this.trackGoogleEvent("Land on Referral Page", "Get Price", "Referral");
    this.trackFacebookEvent("Land on Household Details Page");

    // check for referral code in url and validate against endpoint
    let referralCode = this.$route.query.ref || localStorage.referralCode;

    this.$store.commit("HIDE_BACK_BTN");

    this.$store.dispatch("getReferralMessage", referralCode);
  },
  components: {
    WalletIcon,
    ChartIcon,
    ThumbsUpIcon,
  },
};
</script>

<style lang="scss" scoped>
.container {
  max-width: 120rem;
}

h1 {
  margin-left: auto;
  margin-right: auto;
}

.benefits {
  display: flex;

  @include media("<medium") {
    flex-direction: column;
    box-shadow: $brand-box-shadow;
    border-radius: $border-radius-small;
  }
}

.benefit {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-basis: 100%;

  padding: $spacing-small;
  margin: $spacing-tiny;

  background: white;
  box-shadow: $brand-box-shadow;
  border-radius: $border-radius-small;

  @include media("<medium") {
    margin: 0 $spacing-small;
    padding: $spacing-small 0;
    box-shadow: none;
    border-radius: 0;
    flex-direction: row;
    align-items: flex-start;

    &:first-child {
      padding-bottom: 0;
    }

    &:last-child {
      padding-top: 0;
    }

    svg {
      margin: $spacing-tiny $spacing-small 0 0;
    }
  }

  .benefit-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-basis: 100%;

    @include media("<medium") {
      align-items: flex-start;
    }

    h2 {
      font-size: $form-font-size;
      font-weight: $font-regular;
      margin: $spacing-tiny 0;
      color: $brand-orange;

      @include media("<medium") {
        text-align: initial;
      }
    }

    p {
      font-size: $small-font-size;
      margin: 0;
      text-align: center;

      @include media("<medium") {
        text-align: initial;
      }
    }
  }
}
</style>
